import { Link } from "react-router-dom";
import { Utils } from "../../../../utils/Utils";
import FreeBadge, { isFreeProduct } from "../../../common/badge/FreeBadge";
import DetailAccentCard from "../../../common/detail/DetailAccentCard";
import { isWebinarSpeaker, userIsWebinarRegistered } from "../webinarAccess";

export default function EnrollSection({ webinar }) {
	const isSpeaker = isWebinarSpeaker(webinar);
	const isRegistered = userIsWebinarRegistered(webinar);
	const isFree = isFreeProduct(webinar);
	const priceToman = Utils.convertTomanComma(webinar.price);

	if (isSpeaker) {
		return (
			<DetailAccentCard bodyClassName="p-4 md:p-5" ariaLabel="برگزارکننده">
				<p className="text-center font-Vazir-600 text-[15px] text-darkBlue">
					شما برگزارکننده این وبینار هستید
				</p>
				<p className="mt-2 text-center font-Vazir-400 text-[13px] text-midGray">
					لینک «ورود سخنران» نزدیک زمان شروع فعال می‌شود.
				</p>
			</DetailAccentCard>
		);
	}

	return (
		<DetailAccentCard bodyClassName="p-4 md:p-5" ariaLabel="ثبت‌نام">
			{isFree ? (
				<div className="flex flex-col items-center gap-3">
					<FreeBadge />
					<p className="font-Vazir-600 text-[15px] text-darkBlue">وبینار رایگان</p>
				</div>
			) : (
				<div className="text-center">
					<span className="font-Vazir-400 text-[13px] text-midGray">قیمت</span>
					<p className="mt-1 font-Vazir-700 text-[18px] text-darkBlue">
						{priceToman}{" "}
						<span className="text-[14px] font-Vazir-400">تومان</span>
					</p>
				</div>
			)}

			{isRegistered && (
				<p className="mt-4 text-center font-Vazir-600 text-[14px] text-secondary-green2">
					ثبت‌نام شده
				</p>
			)}

			{!isRegistered && webinar.is_enrollable && (
				<Link
					to={`/webinar_purchase/${webinar.id}/`}
					className="mt-4 block rounded-[10px] bg-cta py-2.5 text-center font-Vazir-600 text-[15px] text-white no-underline transition hover:opacity-90"
				>
					{isFree ? "ثبت‌نام رایگان" : "ثبت‌نام"}
				</Link>
			)}
		</DetailAccentCard>
	);
}
